import * as ClientAccess from "./ClientAccess";
import * as Conversations from "./Conversations";
import * as Participants from "./Participants";
import * as Notifications from "./Notifications";

const conversations = {
    ClientAccess,
    Conversations,
    Participants,
    Notifications,
};

export default conversations;
